import type { BreadcrumbItem } from "~/components/ui/breadcrumb/CreateBreadcrumb.vue";

type TranslateFn = (key: string, defaultValue?: string | number) => string;

const getCategoryArray = (obj?: APICategory, path = "", t?: TranslateFn): BreadcrumbItem[] => {
    if (!obj) return [];

    const translate = t ?? ((key: string, defaultValue?: string | number) => defaultValue?.toString() ?? key);

    // Base case: if the object has no 'parent' key, return an array with this object
    if (!obj.parent) {
        return [
            {
                label: translate(`category.name.${obj.name}`, obj.name),
                to: `/categories${path ? "/" + path + "/" + obj.slug : "/" + obj.slug}`,
                icon: {
                    name: obj.icon ?? "ph:empty",
                },
            },
        ];
    }

    // Recursive case: process parent first
    const parentArray: BreadcrumbItem[] = getCategoryArray(obj.parent, path + "/" + obj.slug, translate);

    // Add current object to the beginning of the array
    const currentLink: BreadcrumbItem = {
        label: translate(`category.name.${obj.name}`, obj.name),
        to: `/categories${path ? "/" + path + "/" + obj.slug : "/" + obj.slug}`,
        icon: {
            name: obj.icon ?? "ph:empty",
        },
    };

    return [currentLink].concat(parentArray);
};

export default getCategoryArray;